import { LoansLandingPage } from 'pageModules/LoansLandingPage';

export default LoansLandingPage;
